import { DatePipe } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import {
  BaseSiteService,
  CmsService,
  GlobalMessageService,
  GlobalMessageType,
  LanguageService,
  RoutingService,
} from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { DataLayerService } from 'src/app/shared/services/data-layer.service';
import { RecaptchaService } from 'src/app/shared/services/recaptcha.service';
import { SharedService } from '../../../shared/services/shared.service';
import { CustomRegistrationService } from '../../custom-registration.service';
import {
  delTimeValue,
  globalErrorMsgEng,
  globalErrorMsgFr,
  siteLanguagesEng,
} from '../../registration.constants';

const maxlengthFourty = 40;
const maxlengthChar = 256;
const maxlengthTwelve = 12;
const charlengthSix = 6;
const nameRegex = '[^@#!$%*()=]+$';
const faxRegex = '^[0-9]{3}-[0-9]{3}-[0-9]{4}$';
const phonepattern = '^[0-9]{3}-[0-9]{3}-[0-9]{4}$';

const emailRegexExp = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,15}$/;

const primaryDataEmail = 'primaryData.email';
const primaryDataFax = 'primaryData.fax';
const invoiceContactEmail = 'invoiceNewContactData.email';
const invoiceContactFax = 'invoiceNewContactData.fax';
const invoiceContactPrimary = 'invoiceNewContactData.primaryContact2';
const shippingContactPrimary = 'shippingNewContactData.primaryContact3';
const shippingContactEmail = 'shippingNewContactData.email';
const shippingContactFax = 'shippingNewContactData.fax';

declare const grecaptcha: any;
declare global {
  interface Window {
    onRecaptchaLoad: () => void;
  }
}

@Component({
    selector: 'app-contacts-information',
    templateUrl: './contacts-information.component.html',
    styleUrls: ['./contacts-information.component.scss'],
    standalone: false
})
export class ContactsInformationComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() formDetails: any;
  @Input() multiFormData: any;
  @Output() pageHeader = new EventEmitter<any>();
  header: string;
  expirationDateBoolean: boolean = true;
  prevDateForExpiration: boolean = false;
  formData: any;
  baseSiteId: any;
  creditInvoice: string;
  cmsResponse: any;
  finalNeedAss: any;
  model: NgbDateStruct;
  model2: NgbDateStruct;
  deaValueValidation: any = 'Valid';
  deaValueValidationforHIN: any = 'Valid';
  contactsForm: FormGroup;
  contactTitle: any[] = [];
  contactRole: any[] = [];
  isPrimaryContact: boolean[] = [true, false];
  isPrimaryFlag: boolean = true;
  isInvoiceContact: boolean[] = [true, false];
  isShippingContact: boolean[] = [true, false];
  preferredContactMethod: string[] = ['INT', 'FAX'];
  accountRegisSub: Subscription;
  contactTitleSub: Subscription;
  contactRoleSub: Subscription;
  maxSelectionDate = new Date();
  dateFormat = 'DD/MM/YYYY';
  fromDate: any;
  errorMessageText: string = globalErrorMsgEng;
  timelist = delTimeValue;
  recaptchaEnabled = false;
  siteKey: string | null = null;
  subRecaptcha: Subscription;
  isFederal: boolean = false;
  emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,15}$/;
  widgetId: any;

  validationType: object;
  constructor(
    private readonly accountRegService: CustomRegistrationService,
    private readonly cdr: ChangeDetectorRef,
    private readonly sharedService: SharedService,
    private readonly user: UserAccountFacade,
    private readonly router: RoutingService,
    private readonly languageService: LanguageService,
    private readonly globalMessage: GlobalMessageService,
    private readonly cmsData: CmsService,
    private readonly baseSiteService: BaseSiteService,
    private readonly recaptchaService: RecaptchaService,
    private datePipe: DatePipe,
    private _dataLayerService: DataLayerService,

  ) { }

  ngAfterViewInit(): void {
    if (window['grecaptcha'] && window['grecaptcha'].enterprise) {
      this.loadRecaptcha();
    }
  }

  ngOnInit(): void {
    this._dataLayerService.addtoDataLayer(
      'accReg_FormEvent',
      '',
      '',
      '',
      'form_step',
      'license'
    );

    this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.header = 'contacts';
    this.creditInvoice = 'invoiceTable';
    this.accountRegService.sectionChange.subscribe((sectionDetails) => {
      this.header = sectionDetails.header;
      this.cdr.detectChanges();
    });

    localStorage.setItem('section', 'Contact');

    this.finalNeedAss = this.cmsData.getComponentData(
      'NeedAssistanceComponent'
    );

    window.scroll(0, 0);
    this.languageService.getActive().subscribe((langRes) => {
      this.errorMessageText =
        langRes === siteLanguagesEng ? globalErrorMsgEng : globalErrorMsgFr;
    });
    this.validationType = {
      firstName: [
        Validators.required,
        Validators.pattern(nameRegex),
        Validators.maxLength(maxlengthFourty),
      ],
      lastName: [
        Validators.required,
        Validators.pattern(nameRegex),
        Validators.maxLength(maxlengthFourty),
      ],
      title: [Validators.required],
      role: [Validators.required],
      preferredContactMethod2: [Validators.required],
      email: [Validators.required, Validators.pattern(emailRegexExp)],
      confirmEmail: new FormControl(null, [
        Validators.required,

        Validators.pattern(emailRegexExp),
        Validators.minLength(charlengthSix),
        Validators.maxLength(maxlengthChar),
      ]),
      stateLicense: [Validators.required],
      dea: [Validators.required],
      deaName: [Validators.required],
      hin: [Validators.required],
      datepicker: [Validators.required],
      phone: new FormControl(null, [Validators.maxLength(maxlengthTwelve)]),
      extension: new FormControl(null, [
        Validators.pattern('[0-9]*$'),
        Validators.maxLength(charlengthSix),
      ]),
    };
    this.accountRegService.getContactTitle({
      enumerationType: 'ContactTitle',
      fields: 'DEFAULT',
    });
    this.accountRegService.getContactRole({
      enumerationType: 'CustomerRole',
      fields: 'DEFAULT',
    });

    this.contactsForm = new FormGroup({
      primaryData: new FormGroup({
        firstName: new FormControl(null, [
          Validators.required,
          Validators.pattern(nameRegex),
          Validators.maxLength(maxlengthFourty),
        ]),
        firstName_repeat: new FormControl(null, [
          Validators.required,
          Validators.pattern(nameRegex),
          Validators.maxLength(maxlengthFourty),
        ]),
        lastName: new FormControl(null, [
          Validators.required,
          Validators.pattern(nameRegex),
          Validators.maxLength(maxlengthFourty),
        ]),
        lastname_repeat: new FormControl(null, [
          Validators.required,
          Validators.pattern(nameRegex),
          Validators.maxLength(maxlengthFourty),
        ]),
        title: new FormControl(null, [Validators.required]),
        title_repeat: new FormControl(null, [Validators.required]),
        role: new FormControl(null, [Validators.required]),
        role_repeat: new FormControl(null),
        dea: new FormControl(null, [Validators.required]),
        dea_repeat: new FormControl(null),
        deaName: new FormControl(null, [
          Validators.maxLength(maxlengthFourty),
          Validators.required,
        ]),
        deaName_repeat: new FormControl(null, [
          Validators.maxLength(maxlengthFourty),
        ]),
        hin: new FormControl(null, [Validators.required]),
        hin_repeat: new FormControl(null),
        stateLicense: new FormControl(null, [
          Validators.required,
          Validators.pattern(nameRegex),
        ]),
        stateLicense_repeat: new FormControl(null),
        datepicker: new FormControl(null, Validators.required),
        datepicker_repeat: new FormControl(null),

        email: new FormControl(null, [
          Validators.required,
          Validators.pattern(emailRegexExp),
        ]),
        email_repeat: new FormControl(null, [
          Validators.required,
          Validators.pattern(emailRegexExp),
        ]),
        confirmEmail: new FormControl(null, [
          Validators.required,
          Validators.pattern(emailRegexExp),
        ]),
        confirmEmail_repeat: new FormControl(null, [
          Validators.required,
          Validators.pattern(emailRegexExp),
        ]),
        fax: new FormControl(null, [
          Validators.pattern(faxRegex),
          Validators.maxLength(maxlengthTwelve),
        ]),
        phone: new FormControl(null, [
          Validators.pattern(faxRegex),
          Validators.maxLength(maxlengthTwelve),
        ]),
        phone_repeat: new FormControl(null, [
          Validators.pattern(faxRegex),
          Validators.maxLength(maxlengthTwelve),
        ]),
        extension: new FormControl(null, [
          Validators.pattern('[0-9]*$'),
          Validators.maxLength(charlengthSix),
        ]),
        extension_repeat: new FormControl(null, [
          Validators.pattern('[0-9]*$'),
          Validators.maxLength(charlengthSix),
        ]),

        sameAsBillingAddress: new FormControl(null),
      }),
    });

    this.contactTitleSub = this.accountRegService.contactTitleData$.subscribe(
      (response) => {
        if (response !== false) {
          this.contactTitle = response;
        }
      }
    );

    this.contactRoleSub = this.accountRegService.contactRoleData$.subscribe(
      (response) => {
        if (response !== false) {
          this.contactRole = response;
        }
      }
    );

    this.contactsForm
      ?.get('primaryData.preferredContactMethod')
      ?.valueChanges.subscribe((value) => {
        this.primaryPreferredContactEvaluation(value);
      });

    this.contactsForm
      ?.get('invoiceNewContactData.preferredContactMethod2')
      ?.valueChanges.subscribe((value) => {
        this.invoicePreferredContactEvaluation(value);
      });

    this.contactsForm
      ?.get(invoiceContactPrimary)
      ?.valueChanges.subscribe((value) => {
        if (value === this.isPrimaryContact[0]) {
          this.removeValidators(
            this.contactsForm.get('invoiceNewContactData') as FormGroup
          );
        } else if (value === this.isPrimaryContact[1]) {
          this.addValidators(
            this.contactsForm.get('invoiceNewContactData') as FormGroup
          );
        } else {
        }
      });

    this.contactsForm
      ?.get('invoiceContact')
      ?.valueChanges.subscribe((value) => {
        if (value === this.isPrimaryContact[1]) {
          this.removeValidators(
            this.contactsForm.get('invoiceNewContactData') as FormGroup
          );
        } else if (
          value === true &&
          this.contactsForm.get(invoiceContactPrimary).value === false
        ) {
          this.addValidators(
            this.contactsForm.get('invoiceNewContactData') as FormGroup
          );
        } else {
        }
      });

    this.contactsForm
      ?.get('shippingContact')
      ?.valueChanges.subscribe((value) => {
        if (value === this.isPrimaryContact[1]) {
          this.removeValidators(
            this.contactsForm.get('shippingNewContactData') as FormGroup
          );
        } else if (
          value === true &&
          this.contactsForm.get(shippingContactPrimary).value === false
        ) {
          this.addValidators(
            this.contactsForm.get('shippingNewContactData') as FormGroup
          );
        } else {
        }
      });

    this.contactsForm
      ?.get(shippingContactPrimary)
      ?.valueChanges.subscribe((value) => {
        if (value === this.isPrimaryContact[0]) {
          this.removeValidators(
            this.contactsForm.get('shippingNewContactData') as FormGroup
          );
        } else if (value === this.isPrimaryContact[1]) {
          this.addValidators(
            this.contactsForm.get('shippingNewContactData') as FormGroup
          );
        } else {
        }
      });

    this.contactsForm
      ?.get('shippingNewContactData.preferredContactMethod3')
      ?.valueChanges.subscribe((value) => {
        this.shippingPreferredContactEvaluation(value);
      });

    this.subRecaptcha = this.recaptchaService
      .isEnabled$()
      .pipe(take(1))
      .subscribe((enabled) => {
        this.recaptchaEnabled = enabled;
        this.siteKey = this.recaptchaService.getSiteKey();
        if (enabled) {
          const pdFormGroup = this.contactsForm.get('primaryData') as FormGroup;
          pdFormGroup.addControl(
            'captcha',
            new FormControl(null, Validators.required)
          );
        }
      });

    window['onRecaptchaLoad'] = () => this.loadRecaptcha();

    const formData_For_Shipping = JSON.parse(
      localStorage.getItem('billingFormDetails')
    );

    const params = {
      facilityCode: formData_For_Shipping?.practiceOrFacilityType,
    };

    this.accountRegService.getFacilityCategory(params).subscribe((res) => {
      if (res && res.includes('FEDERAL')) {
        this.isFederal = true;
        this.contactsForm.controls.primaryData.patchValue({
          stateLicense: 'EXEMPT',
          stateLicense_repeat: 'EXEMPT',
          datepicker: '12/31/9999',
        });
        const stateLicense =
          this.contactsForm.controls.primaryData.get('stateLicense');
        stateLicense.clearValidators();
        stateLicense.markAsUntouched();
        stateLicense.markAsPristine();
        stateLicense.updateValueAndValidity();
        const datepicker =
          this.contactsForm.controls.primaryData.get('datepicker');
        datepicker.clearValidators();
        datepicker.markAsUntouched();
        datepicker.markAsPristine();
        datepicker.updateValueAndValidity();
      } else {
        this.isFederal = false;
        this.contactsForm.controls.primaryData.patchValue({
          stateLicense: '',
          stateLicense_repeat: '',
          datepicker: '',
        });
      }
    });
  }

  private loadRecaptcha() {
    const container = document.getElementById('recaptcha-container');
    if (!container || !window['grecaptcha'] || !grecaptcha.enterprise.render) {
      console.error('Recaptcha not ready');
      return;
    }

    this.widgetId = grecaptcha.enterprise.render('recaptcha-container', {
      sitekey: this.siteKey,
      theme: 'light',
      size: 'normal',
      callback: (token: string) => this.onCaptchaSuccess(token)
    });
  }

  private onCaptchaSuccess(token: string) {
    //console.log('Captcha success token:', token);
    this.contactsForm.controls.primaryData.patchValue({ captcha: token });
  }


  public removeValidators(form: FormGroup) {
    for (const key in form.controls) {
      if (!!this.validationType[key]) {
        form.get(key).clearValidators();
        form.get(key).updateValueAndValidity();
      }
    }
  }

  dateValidation(e) {
    setTimeout(() => {
      var expDate_val = this.datePipe.transform(e, 'MM/dd/yyyy');
      if (
        null != expDate_val &&
        expDate_val.length > 0 &&
        expDate_val.length < 10
      ) {
        this.expirationDateBoolean = false;
        this.prevDateForExpiration = false;
        this.contactsForm.controls.primaryData
          .get('datepicker')
          .setErrors({ incorrect: true });
        this.contactsForm.setErrors({ invalid: true });
        this.cdr.detectChanges();
      } else if (expDate_val.length == 0) {
        this.expirationDateBoolean = true;
        this.contactsForm.controls.primaryData.get('datepicker').valid;
        this.cdr.detectChanges();
      } else {
        var ArrForDate_exp = expDate_val
          .split('/')
          .map((part) => parseInt(part, 10));
        if (new Date(expDate_val).getTime() <= Date.now()) {
          this.prevDateForExpiration = true;
          this.expirationDateBoolean = true;
          this.contactsForm.controls.primaryData
            .get('datepicker')
            .setErrors({ incorrect: true });
          this.contactsForm.controls.primaryData.get('datepicker').invalid;
          //this.contactsForm.setErrors({ invalid: true });
          //this.contactsForm.controls.primaryData.get('datepicker').setValue('');
          this.cdr.detectChanges();
        } else {
          this.prevDateForExpiration = false;
          if (
            ArrForDate_exp[0] == 0 ||
            ArrForDate_exp[1] == 0 ||
            ArrForDate_exp[2] == 0
          ) {
            this.expirationDateBoolean = false;
            this.contactsForm.controls.primaryData
              .get('datepicker')
              .setErrors({ incorrect: true });
            this.contactsForm.setErrors({ invalid: true });
            this.cdr.detectChanges();
          } else {
            if (
              ArrForDate_exp[0] > 12 ||
              ArrForDate_exp[1] > 31 ||
              (ArrForDate_exp[2] > 2050 && ArrForDate_exp[2] !== 9999)
            ) {
              this.expirationDateBoolean = false;

              this.contactsForm.controls.primaryData
                .get('datepicker')
                .setErrors({ incorrect: true });
              this.contactsForm.setErrors({ invalid: true });
              this.cdr.detectChanges();
            } else {
              this.expirationDateBoolean = true;
              this.contactsForm.controls.primaryData
                .get('datepicker')
                .setErrors(null);
              this.contactsForm.setErrors(null);
              this.expirationDateBoolean = false;
              this.prevDateForExpiration = false;
              this.cdr.detectChanges();
            }
          }
        }
      }
      if (expDate_val == '' || this.prevDateForExpiration) {
        e.target.focus();
        this.contactsForm.controls.primaryData
          .get('datepicker')
          .markAsTouched();
        this.contactsForm.controls.primaryData
          .get('datepicker')
          .updateValueAndValidity();
      }
      this.cdr.detectChanges();
    }, 200);
  }

  public addValidators(form: FormGroup) {
    for (const key in form.controls) {
      if (!!this.validationType[key]) {
        form.get(key).setValidators(this.validationType[key]);
        form.get(key).updateValueAndValidity();
      }
    }
  }

  validateHIN(e) {
    if (e.target.value.length === 0) {
      this.deaValueValidationforHIN = 'Valid';
    } else {
      this.deaValueValidationforHIN = 'notValid';
      if (e.target.value.length === 9) {
        this.deaValueValidationforHIN = 'Valid';
      }
    }
  }

  validatepattrn(e) {
    if (e.target.value.length === 0) {
      this.deaValueValidation = 'Valid';
    } else {
      this.deaValueValidation = 'notValid';
      if (e.target.value.length === 9) {
        let firstChar = e.target.value.substring(0, 1);
        let first2Chars = e.target.value.substring(1, 2);
        let thirdPos = e.target.value.substring(2, 3);
        let forthPos = e.target.value.substring(3, 4);
        let fifthPos = e.target.value.substring(4, 5);
        let sixthPos = e.target.value.substring(5, 6);
        let seventhPos = e.target.value.substring(6, 7);
        let eightthPos = e.target.value.substring(7, 8);
        let ninthPos = e.target.value.substring(8, 9);

        if (/[a-z]/i.test(first2Chars) && /[a-z]/i.test(firstChar)) {
          if (
            /[0-9]/i.test(thirdPos) &&
            /[0-9]/i.test(thirdPos) &&
            /[0-9]/i.test(forthPos) &&
            /[0-9]/i.test(fifthPos) &&
            /[0-9]/i.test(sixthPos) &&
            /[0-9]/i.test(seventhPos) &&
            /[0-9]/i.test(eightthPos) &&
            /[0-9]/i.test(ninthPos)
          ) {
            this.deaValueValidation = 'Valid';
          }
        } else {
          this.deaValueValidation = 'notValid';
        }
      }
    }
  }

  primaryPreferredContactEvaluation(value) {
    if (value === this.preferredContactMethod[0]) {
      this.contactsForm
        .get(primaryDataEmail)
        .setValidators([
          Validators.required,
          Validators.pattern(emailRegexExp),
        ]);
      this.contactsForm.get(primaryDataFax).clearValidators();
      this.contactsForm
        .get(primaryDataFax)
        .setValidators([
          Validators.pattern(faxRegex),
          Validators.maxLength(maxlengthTwelve),
        ]);
      this.contactsForm.get(primaryDataEmail).updateValueAndValidity();
      this.contactsForm.get(primaryDataFax).updateValueAndValidity();
    } else if (value === this.preferredContactMethod[1]) {
      this.contactsForm
        .get(primaryDataFax)
        .setValidators([
          Validators.required,
          Validators.pattern(faxRegex),
          Validators.maxLength(maxlengthTwelve),
        ]);
      this.contactsForm.get(primaryDataEmail).clearValidators();
      this.contactsForm
        .get(primaryDataEmail)
        .setValidators([Validators.pattern(emailRegexExp)]);
      this.contactsForm.get(primaryDataFax).updateValueAndValidity();
      this.contactsForm.get(primaryDataEmail).updateValueAndValidity();
    } else {
    }
  }

  invoicePreferredContactEvaluation(value) {
    if (value === this.preferredContactMethod[0]) {
      this.contactsForm
        .get(invoiceContactEmail)
        .setValidators([
          Validators.required,
          Validators.pattern(emailRegexExp),
        ]);
      this.contactsForm.get(invoiceContactFax).clearValidators();
      this.contactsForm
        .get(invoiceContactFax)
        .setValidators([
          Validators.pattern(faxRegex),
          Validators.maxLength(maxlengthTwelve),
        ]);
      this.contactsForm.get(invoiceContactEmail).updateValueAndValidity();
      this.contactsForm.get(invoiceContactFax).updateValueAndValidity();
    } else if (value === this.preferredContactMethod[1]) {
      this.contactsForm
        .get(invoiceContactFax)
        .setValidators([
          Validators.required,
          Validators.pattern(faxRegex),
          Validators.maxLength(maxlengthTwelve),
        ]);
      this.contactsForm.get(invoiceContactEmail).clearValidators();
      this.contactsForm
        .get(invoiceContactEmail)
        .setValidators([Validators.pattern(emailRegexExp)]);
      this.contactsForm.get(invoiceContactFax).updateValueAndValidity();
      this.contactsForm.get(invoiceContactEmail).updateValueAndValidity();
    } else {
    }
  }

  shippingPreferredContactEvaluation(value) {
    if (value === this.preferredContactMethod[0]) {
      this.contactsForm
        .get(shippingContactEmail)
        .setValidators([
          Validators.required,
          Validators.pattern(emailRegexExp),
        ]);
      this.contactsForm.get(shippingContactFax).clearValidators();
      this.contactsForm
        .get(shippingContactFax)
        .setValidators([
          Validators.pattern(faxRegex),
          Validators.maxLength(maxlengthTwelve),
        ]);
      this.contactsForm.get(shippingContactEmail).updateValueAndValidity();
      this.contactsForm.get(shippingContactFax).updateValueAndValidity();
    } else if (value === this.preferredContactMethod[1]) {
      this.contactsForm
        .get(shippingContactFax)
        .setValidators([
          Validators.required,
          Validators.pattern(faxRegex),
          Validators.maxLength(maxlengthTwelve),
        ]);
      this.contactsForm.get(shippingContactEmail).clearValidators();
      this.contactsForm
        .get(shippingContactEmail)
        .setValidators([Validators.pattern(emailRegexExp)]);
      this.contactsForm.get(shippingContactFax).updateValueAndValidity();
      this.contactsForm.get(shippingContactEmail).updateValueAndValidity();
    } else {
    }
  }

  back() {
    const shippingDetails = {
      header: 'shippingDetails',
      form: this.formDetails,
      forms: this.formDetails,
    };
    this.pageHeader.emit(shippingDetails);
    this.accountRegService.sectionChange.next(shippingDetails);
  }

  showCaptchaErrorMsg = false;
  createAccount() {
    if (this.recaptchaEnabled) {
      this.showCaptchaErrorMsg =
        this.contactsForm.controls.primaryData['controls'].captcha.errors
          ?.required && true;
    }

    localStorage.setItem(
      'contactDetails',
      JSON.stringify(this.contactsForm.value.primaryData)
    );
    this.replicateForm('Y');
    if (!this.isPrimaryFlag) {
      if (
        this.contactsForm.value.primaryData.stateLicense_repeat != null &&
        this.contactsForm.value.primaryData.stateLicense != null &&
        this.contactsForm.value.primaryData.email != null &&
        this.contactsForm.value.primaryData.email_repeat != null &&
        this.contactsForm.value.primaryData.confirmEmail != null &&
        this.contactsForm.value.primaryData.confirmEmail_repeat != null &&
        this.contactsForm.value.primaryData.datepicker != null &&
        this.contactsForm.value.primaryData.datepicker_repeat != null &&
        this.contactsForm.value.primaryData.firstName != null &&
        this.contactsForm.value.primaryData.firstName_repeat != null &&
        this.contactsForm.value.primaryData.lastName != null &&
        this.contactsForm.value.primaryData.lastName_repeat != null &&
        this.contactsForm.value.primaryData.title != null &&
        this.contactsForm.value.primaryData.title_repeat != null
      ) {
        this.contactsForm.value.primaryData.status = 'VALID';
      } else {
        this.contactsForm.value.primaryData.status = 'INVALID';
      }
    } else if (this.isPrimaryFlag) {
      if (
        this.contactsForm.value.primaryData.stateLicense != null &&
        this.contactsForm.value.primaryData.email != null &&
        this.contactsForm.value.primaryData.confirmEmail != null &&
        this.contactsForm.value.primaryData.datepicker != null &&
        this.contactsForm.value.primaryData.firstName != null &&
        this.contactsForm.value.primaryData.lastName != null &&
        this.contactsForm.value.primaryData.title != null &&
        this.contactsForm.value.primaryData.captcha != null
      ) {
        this.contactsForm.value.primaryData.status = 'VALID';
      } else {
        this.contactsForm.value.primaryData.status = 'INVALID';
      }
    }

    if (this.contactsForm.valid) {
      let dateValueforSL = this.datePipe.transform(
        this.contactsForm.value.primaryData.datepicker,
        'MM/dd/yyyy'
      );
      let dateValueforSL_repeat;
      if (dateValueforSL_repeat !== undefined) {
        dateValueforSL_repeat =
          this.contactsForm.value.primaryData.datepicker_repeat.month +
          '/' +
          this.contactsForm.value.primaryData.datepicker_repeat.day +
          '/' +
          this.contactsForm.value.primaryData.datepicker_repeat.year;
      } else {
        dateValueforSL_repeat = '';
      }
      this.multiFormData.contacts = [this.contactsForm.value.primaryData];
      this.contactsForm.markAllAsTouched();

      const formData_For_Shipping = JSON.parse(
        localStorage.getItem('billingFormDetails')
      );
      let deliveryHrs = [];
      let billFromDet = JSON.parse(localStorage.getItem('billingFormDetails'));
      let obj_DH;
      if (
        billFromDet.mondayFromTime != null &&
        billFromDet.mondayToTime != null
      ) {
        let matchedFromTime = this.timelist.find(
          (e) => e.id === billFromDet.mondayFromTime
        );
        let matchedToTime = this.timelist.find(
          (e) => e.id === billFromDet.mondayToTime
        );
        obj_DH = {
          day: 'MONDAY',
          fromTime: matchedFromTime.name,
          toTime: matchedToTime.name,
        };
        deliveryHrs.push(obj_DH);
      }

      if (billFromDet.tuesFromTime != null && billFromDet.tuesToTime != null) {
        let matchedFromTime = this.timelist.find(
          (e) => e.id === billFromDet.tuesFromTime
        );
        let matchedToTime = this.timelist.find(
          (e) => e.id === billFromDet.tuesToTime
        );
        obj_DH = {
          day: 'TUESDAY',
          fromTime: matchedFromTime.name,
          toTime: matchedToTime.name,
        };
        deliveryHrs.push(obj_DH);
      }

      if (billFromDet.wedFromTime != null && billFromDet.wedToTime != null) {
        let matchedFromTime = this.timelist.find(
          (e) => e.id === billFromDet.wedFromTime
        );
        let matchedToTime = this.timelist.find(
          (e) => e.id === billFromDet.wedToTime
        );
        obj_DH = {
          day: 'WEDNESDAY',
          fromTime: matchedFromTime.name,
          toTime: matchedToTime.name,
        };
        deliveryHrs.push(obj_DH);
      }

      if (
        billFromDet.thursFromTime != null &&
        billFromDet.thursToTime != null
      ) {
        let matchedFromTime = this.timelist.find(
          (e) => e.id === billFromDet.thursFromTime
        );
        let matchedToTime = this.timelist.find(
          (e) => e.id === billFromDet.thursToTime
        );
        obj_DH = {
          day: 'THURSDAY',
          fromTime: matchedFromTime.name,
          toTime: matchedToTime.name,
        };
        deliveryHrs.push(obj_DH);
      }

      if (
        billFromDet.fridayFromTime != null &&
        billFromDet.fridayToTime != null
      ) {
        let matchedFromTime = this.timelist.find(
          (e) => e.id === billFromDet.fridayFromTime
        );
        let matchedToTime = this.timelist.find(
          (e) => e.id === billFromDet.fridayToTime
        );
        obj_DH = {
          day: 'FRIDAY',
          fromTime: matchedFromTime.name,
          toTime: matchedToTime.name,
        };
        deliveryHrs.push(obj_DH);
      }

      let address = [];
      let obj_shipping = {
        facilityName: formData_For_Shipping?.facilityName,
        legalName: formData_For_Shipping?.facilityName2,
        attention: formData_For_Shipping?.attention,
        practiceOrFacilityType: formData_For_Shipping?.practiceOrFacilityType,
        billingAddress: false,
        country: {
          isocode: formData_For_Shipping?.region.isocode,
          name: formData_For_Shipping?.region.name,
        },
        deliveryHours: deliveryHrs,
        email: formData_For_Shipping?.email,
        extension:
          formData_For_Shipping.extension != null
            ? formData_For_Shipping.extension
            : '',
        line1: formData_For_Shipping?.line1,
        line2: formData_For_Shipping?.line2,
        phone: formData_For_Shipping?.phone,

        town: formData_For_Shipping?.town,
        postalCode: formData_For_Shipping?.postalCode,
        region: {
          countryIso: 'US',
          isocode: formData_For_Shipping?.region.isocode,
          isocodeShort: formData_For_Shipping?.region.isocode,
          name: formData_For_Shipping?.region.name,
        },

        shippingAddress: true,
        financialResponsible: false,
      };
      address.push(obj_shipping);
      let shippingDetails = JSON.parse(
        localStorage.getItem('finalBillingDetails')
      );

      let obj_billing = {
        facilityName: shippingDetails['facilityName'],
        legalName: shippingDetails['facilityName2'],
        attention: shippingDetails['attention'],
        practiceOrFacilityType: formData_For_Shipping?.practiceOrFacilityType,
        billingAddress: true,
        country: {
          isocode: shippingDetails['region'].isocode,

          name: shippingDetails['region'].name,
        },
        deliveryHours: [],
        email: shippingDetails['email'],
        extension:
          shippingDetails['extension'] != null
            ? shippingDetails['extension']
            : '',
        line1: shippingDetails['line1'],
        line2: shippingDetails['line2'],
        phone: shippingDetails['phone'],

        town: shippingDetails['town'],
        postalCode: shippingDetails['postalCode'],
        region: {
          countryIso: 'US',
          isocode: shippingDetails['region'].isocode,
          isocodeShort: shippingDetails['region'].isocode,

          name: shippingDetails['region'].name,
        },

        shippingAddress: false,
        financialResponsible: !shippingDetails['yellowFeverForShippingAddr']
          ? false
          : true,
      };

      if (!shippingDetails['sameAsBillingAddress']) {
        address.push(obj_billing);
      }

      let obj_financiallyresponsible = {
        facilityName: localStorage.getItem('replicateForm')
          ? shippingDetails['facilityName_repeat']
          : shippingDetails['facilityName'],
        legalName: localStorage.getItem('replicateForm')
          ? shippingDetails['facilityName_repeat2']
          : shippingDetails['facilityName2'],
        attention: shippingDetails['attention_repeat'],
        practiceOrFacilityType: formData_For_Shipping?.practiceOrFacilityType,
        billingAddress: false,
        country: {
          isocode: localStorage.getItem('replicateForm')
            ? shippingDetails['region_repeat'].isocode
            : shippingDetails['region'].isocode,

          countryIso: localStorage.getItem('replicateForm')
            ? shippingDetails['region_repeat'].name
            : shippingDetails['region'].name,
        },
        deliveryHours: [],
        email: '',
        extension:
          shippingDetails['extension_repeat'] != null
            ? shippingDetails['extension_repeat']
            : '',
        line1: localStorage.getItem('replicateForm')
          ? shippingDetails['line1_repeat']
          : shippingDetails['line1'],
        line2: localStorage.getItem('replicateForm')
          ? shippingDetails['line2_repeat']
          : shippingDetails['line2'],
        phone: localStorage.getItem('replicateForm')
          ? shippingDetails['phone_repeat']
          : shippingDetails['phone'],

        town: localStorage.getItem('replicateForm')
          ? shippingDetails['town_repeat']
          : shippingDetails['town'],
        postalCode: localStorage.getItem('replicateForm')
          ? shippingDetails['postalCode_repeat']
          : shippingDetails['postalCode'],
        region: {
          countryIso: 'US',
          isocode: localStorage.getItem('replicateForm')
            ? shippingDetails['region_repeat'].isocode
            : shippingDetails['region'].isocode,
          isocodeShort: localStorage.getItem('replicateForm')
            ? shippingDetails['region_repeat'].isocode
            : shippingDetails['region'].isocode,

          name: localStorage.getItem('replicateForm')
            ? shippingDetails['region_repeat'].name
            : shippingDetails['region'].name,
        },

        shippingAddress: false,
        financialResponsible: true,
      };

      if (!shippingDetails['yellowFeverForShippingAddr']) {
        address.push(obj_financiallyresponsible);
      }

      let contactDetails = JSON.parse(localStorage.getItem('contactDetails'));
      let contacts = [];
      let obj_contacts = {
        stateLicense: contactDetails.stateLicense,
        stateLicenseExp: dateValueforSL,
        hin: contactDetails.hin != null ? contactDetails.hin : '',
        deaName: contactDetails.deaName != null ? contactDetails.deaName : '',
        dea: contactDetails.dea != null ? contactDetails.dea : '',
        email: contactDetails.email !== '' ? contactDetails.email : '',
        firstName:
          contactDetails.firstName !== '' ? contactDetails.firstName : '',
        lastName: contactDetails.lastName !== '' ? contactDetails.lastName : '',
        phone: contactDetails.phone !== '' ? contactDetails.phone : '',
        extension:
          contactDetails.extension != null ? contactDetails.extension : '',

        primaryContact: true,
        title: contactDetails.title !== '' ? contactDetails.title : '',
        role: contactDetails.role !== '' ? contactDetails.role : '',
        orderCreationPlan: formData_For_Shipping?.orderCreationPlan,
        contractGroupName: formData_For_Shipping?.contractGroupName,
        invoiceEmailId: shippingDetails["invoiceEmail"],
        statementEmailId: shippingDetails["stmntEmail"]
      };

      contacts.push(obj_contacts);

      if (address.length < 2) {
        address.forEach((el) => {
          el.billingAddress = true;
          el.financialResponsible = true;
          el.shippingAddress = true;
        });
      }
      if (address.length > 2) {
        address.forEach(function callback(value, index) {
          if (index === 0) {
            value.shippingAddress = true;
            value.billingAddress = false;
            value.financialResponsible = false;
          }
          if (index === 1) {
            value.shippingAddress = false;
            value.billingAddress = true;
            value.financialResponsible = false;
          }
          if (index === 2) {
            value.shippingAddress = false;
            value.billingAddress = false;
            value.financialResponsible = true;
          }
        });
      } else {
        address.forEach(function callback(value, index) {
          if (index === 0) {
            value.shippingAddress = true;
            value.billingAddress = shippingDetails['sameAsBillingAddress']
              ? true
              : false;
            value.financialResponsible = shippingDetails[
              'yellowFeverForShippingAddr'
            ]
              ? true
              : false;
          }
          if (index === 1) {
            value.shippingAddress = false;
            value.billingAddress = shippingDetails['sameAsBillingAddress']
              ? false
              : true;
            value.financialResponsible = shippingDetails[
              'yellowFeverForShippingAddr'
            ]
              ? false
              : true;
          }
        });
      }

      let obj = {
        addresses: address,
        contacts: contacts,
        captchaToken: this.contactsForm.value.primaryData.captcha,
      };
      this.accountRegisSub = this.accountRegService
        .postAccountRegistration(obj)
        .subscribe((res) => {
          if (res === null) {
            const contactDetails = { header: 'confirmation' };
            !!localStorage.getItem('accountConfirmationData')
              ? localStorage.removeItem('accountConfirmationData')
              : null;
            localStorage.setItem(
              'accountConfirmationData',
              JSON.stringify(contactDetails)
            );
            this.sharedService.setSessionStorage(
              'accountConfirmationData',
              contactDetails
            );
            this.router.goByUrl('/register/confirm');

            this._dataLayerService.addtoDataLayer(
              'accReg_FormEvent',
              '',
              '',
              '',
              'form_submit',
              'license'
            );
          } else if (res['status'] === 'success') {
            this.router.goByUrl('/register/confirm');

            this._dataLayerService.addtoDataLayer(
              'accReg_FormEvent',
              '',
              '',
              '',
              'form_submit',
              'license'
            );
          } else {
            this.globalMessage.add(
              'Something went wrong',
              GlobalMessageType.MSG_TYPE_ERROR
            );
            this._dataLayerService.addtoDataLayer(
              'accReg_FormEvent',
              '',
              '',
              '',
              'form_error',
              'license',
              'form'
            );
          }
        });
    } else {
      window.scroll(0, 0);
      this.contactsForm.updateValueAndValidity();
      this.contactsForm.markAllAsTouched();
      this.globalMessage.add(
        this.errorMessageText,
        GlobalMessageType.MSG_TYPE_ERROR
      );
      this._dataLayerService.addtoDataLayer(
        'accReg_FormEvent',
        '',
        '',
        '',
        'form_error',
        'license',
        'tab'
      );
    }
  }

  organizeData() {
    this.formDetails.contacts = [];
    const pContacts = {
      primaryContact: false,
      invoiceContact: false,
      shippingContact: false,
    };
    pContacts.primaryContact = this.contactsForm.get('primaryContact').value;
    pContacts.invoiceContact =
      !!this.contactsForm.get('invoiceContact').value &&
        !this.contactsForm.get(invoiceContactPrimary).value
        ? false
        : this.contactsForm.get('invoiceContact').value;
    pContacts.shippingContact =
      !!this.contactsForm.get('shippingContact').value &&
        !this.contactsForm.get(shippingContactPrimary).value
        ? false
        : this.contactsForm.get('shippingContact').value;
    const primaryObj = {
      ...pContacts,
      ...this.contactsForm.get('primaryData').value,
    };
    primaryObj.email = this.contactsForm.get(primaryDataEmail).value;
    primaryObj.fax = this.contactsForm.get(primaryDataFax).value;
    this.formDetails.contacts.push(primaryObj);
    const propertyNames = Object.keys(
      this.contactsForm.get('primaryData').value
    );
    if (!!propertyNames && propertyNames.length > 0) {
      const arr = ['preferredContactMethod'];
      for (const elem of arr) {
        const ind = propertyNames.indexOf(elem);
        if (ind >= 0) {
          propertyNames.splice(ind, 1);
        }
      }
    }
    this.organizeInvoiceContactData(propertyNames);
    this.organizeShippingContactData(propertyNames);
  }

  organizeInvoiceContactData(propertyNames) {
    if (
      !!this.contactsForm.get('invoiceContact').value &&
      !this.contactsForm.get(invoiceContactPrimary).value
    ) {
      const obj = {
        primaryContact: false,
        shippingContact: false,
        invoiceContact: true,
        preferredContactMethod: '',
      };
      for (const key of propertyNames) {
        obj[key] = this.contactsForm.get(`invoiceNewContactData.${key}`).value;
      }
      obj.preferredContactMethod = this.contactsForm.get(
        'invoiceNewContactData.preferredContactMethod2'
      ).value;
      obj['email'] = this.contactsForm.get(invoiceContactEmail).value;
      obj['fax'] = this.contactsForm.get(invoiceContactFax).value;
      this.formDetails.contacts.push(obj);
    }
  }

  organizeShippingContactData(propertyNames) {
    if (
      !!this.contactsForm.get('shippingContact').value &&
      !this.contactsForm.get(shippingContactPrimary).value
    ) {
      const obj = {
        primaryContact: false,
        shippingContact: true,
        invoiceContact: false,
        preferredContactMethod: '',
      };
      for (const key of propertyNames) {
        obj[key] = this.contactsForm.get(`shippingNewContactData.${key}`).value;
      }
      obj.preferredContactMethod = this.contactsForm.get(
        'shippingNewContactData.preferredContactMethod3'
      ).value;
      obj['email'] = this.contactsForm.get(shippingContactEmail).value;
      obj['fax'] = this.contactsForm.get(shippingContactFax).value;
      this.formDetails.contacts.push(obj);
    }
  }

  replicateForm(flag) {
    if (flag === 'N') {
      this.isPrimaryFlag = false;
      this.contactsForm.markAsUntouched();
      this.contactsForm
        .get('primaryData')
        .get('firstName_repeat')
        .setValidators([
          Validators.required,
          Validators.pattern(nameRegex),
          Validators.maxLength(maxlengthChar),
        ]);
      this.contactsForm
        .get('primaryData')
        .get('lastname_repeat')
        .setValidators([
          Validators.required,
          Validators.pattern(nameRegex),
          Validators.maxLength(maxlengthChar),
        ]);
      this.contactsForm
        .get('primaryData')
        .get('confirmEmail_repeat')
        .setValidators([
          Validators.required,
          Validators.pattern(emailRegexExp),
        ]);
      this.contactsForm
        .get('primaryData')
        .get('email_repeat')
        .setValidators([
          Validators.required,
          Validators.pattern(emailRegexExp),
        ]);
      this.contactsForm
        .get('primaryData')
        .get('title_repeat')
        .setValidators([Validators.required]);
      this.contactsForm
        .get('primaryData')
        .get('firstName_repeat')
        .updateValueAndValidity();
      this.contactsForm
        .get('primaryData')
        .get('lastname_repeat')
        .updateValueAndValidity();
      this.contactsForm
        .get('primaryData')
        .get('confirmEmail_repeat')
        .updateValueAndValidity();
      this.contactsForm
        .get('primaryData')
        .get('email_repeat')
        .updateValueAndValidity();
      this.contactsForm
        .get('primaryData')
        .get('title_repeat')
        .updateValueAndValidity();
    } else {
      this.isPrimaryFlag = true;

      this.contactsForm
        .get('primaryData')
        .get('firstName_repeat')
        .clearValidators();
      this.contactsForm
        .get('primaryData')
        .get('lastname_repeat')
        .clearValidators();
      this.contactsForm
        .get('primaryData')
        .get('confirmEmail_repeat')
        .clearValidators();
      this.contactsForm
        .get('primaryData')
        .get('email_repeat')
        .clearValidators();
      this.contactsForm
        .get('primaryData')
        .get('title_repeat')
        .clearValidators();
      this.contactsForm
        .get('primaryData')
        .get('firstName_repeat')
        .updateValueAndValidity();
      this.contactsForm
        .get('primaryData')
        .get('lastname_repeat')
        .updateValueAndValidity();
      this.contactsForm
        .get('primaryData')
        .get('confirmEmail_repeat')
        .updateValueAndValidity();
      this.contactsForm
        .get('primaryData')
        .get('email_repeat')
        .updateValueAndValidity();
      this.contactsForm
        .get('primaryData')
        .get('title_repeat')
        .updateValueAndValidity();
    }
  }
  ngOnDestroy() {
    this.contactTitleSub?.unsubscribe();
    this.contactRoleSub?.unsubscribe();
    this.accountRegisSub?.unsubscribe();
    this.subRecaptcha?.unsubscribe();
  }
  onlyNumber(evt) {
    evt = evt ? evt : window.event;
    let charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  toggleGroup($event: Event): void {
    const checkbox = $event.target as HTMLInputElement;
    const group = checkbox.closest('.toggle-group') as HTMLElement;

    const inputs = group.querySelectorAll<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >('input:not([type="checkbox"]), select, textarea');

    inputs.forEach((el) => {
      const controlName = el.getAttribute('formControlName');
      if (!controlName) {
        return;
      }

      const ctrl = this.contactsForm.controls.primaryData.get(controlName);
      if (!ctrl) {
        return;
      }

      if (checkbox.checked) {
        ctrl.clearValidators();
        ctrl.setValue('');
        ctrl.markAsUntouched();
        ctrl.markAsPristine();
        ctrl.updateValueAndValidity();
        ctrl.disable();
        if (checkbox.id === 'hinCheckbox')
          this.deaValueValidationforHIN = 'Valid';
        if (checkbox.id === 'deaCheckbox') this.deaValueValidation = 'Valid';
      } else {
        ctrl.setValidators([Validators.required]);
        ctrl.enable();
      }

      ctrl.updateValueAndValidity();
    });


    if (this.isFederal && checkbox.checked) {
      const siblingId =
        checkbox.id === 'hinCheckbox' ? 'deaCheckbox' : 'hinCheckbox';
      const sibling = document.querySelector<HTMLInputElement>(`#${siblingId}`);

      // const federalBlock = sibling.closest('.isFederal') as HTMLElement | null;
      // if (!federalBlock) return;

      if (sibling && sibling.checked) {
        sibling.checked = false;
        sibling.dispatchEvent(new Event('change'));
      }
    }
  }
}